import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useFirestore } from '../contexts/FirestoreContext';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const NewDocument = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { db } = useFirestore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [document, setDocument] = useState({
    title: '',
    description: '',
    file: null
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!document.file) {
        throw new Error('Please select a file to upload');
      }

      const storage = getStorage();
      const storageRef = ref(storage, `${currentUser.orgId}/${document.file.name}`);
      await uploadBytes(storageRef, document.file);
      const downloadURL = await getDownloadURL(storageRef);

      const docData = {
        ...document,
        orgId: currentUser.orgId,
        createdBy: currentUser.uid,
        downloadURL,
        createdAt: serverTimestamp()
      };

      await addDoc(collection(db, 'documents'), docData);
      navigate('/documents');
    } catch (error) {
      console.error('Error uploading document:', error);
      setError(error.message || 'Error uploading document');
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setDocument(prev => ({
        ...prev,
        file,
        title: file.name
      }));
    }
  };

  return (
    <div className="p-4">
      {/* Header Banner - Matching other pages */}
      <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm">
        <h1 className="h2 mb-0">New Document</h1>
        <button
          className="btn btn-secondary"
          onClick={() => navigate('/documents')}
          style={{ borderColor: '#39325b', color: '#39325b' }}
        >
          Cancel
        </button>
      </div>

      {/* Main Content Card */}
      <div className="card shadow-sm">
        <div className="card-body p-4">
          <form onSubmit={handleSubmit}>
            {/* Title Field */}
            <div className="mb-4">
              <label className="form-label fw-bold">Title</label>
              <input
                type="text"
                value={document.title}
                onChange={(e) => setDocument(prev => ({ ...prev, title: e.target.value }))}
                className="form-control"
                placeholder="Enter document title"
                required
              />
            </div>

            {/* Description Field */}
            <div className="mb-4">
              <label className="form-label fw-bold">Description</label>
              <textarea
                value={document.description}
                onChange={(e) => setDocument(prev => ({ ...prev, description: e.target.value }))}
                className="form-control"
                rows={4}
                placeholder="Enter document description"
              />
            </div>

            {/* File Upload Field */}
            <div className="mb-4">
              <label className="form-label fw-bold">File</label>
              <div className="input-group">
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="form-control"
                  accept=".pdf,.doc,.docx,.txt"
                  required
                />
                {document.file && (
                  <span className="input-group-text">
                    {document.file.name}
                  </span>
                )}
              </div>
              <small className="text-muted">
                Supported formats: PDF, DOC, DOCX, TXT
              </small>
            </div>

            {/* Error Message */}
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {/* Submit Button */}
            <div className="d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
                style={{ backgroundColor: '#39325b', borderColor: '#39325b' }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Uploading...
                  </>
                ) : (
                  'Upload Document'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewDocument; 